<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h2>Pedidos reenviados</h2>
        <p>Esta tela lista os pedidos da Loja Virtual que foram reenviados, após a solicitação na página pública de Ajuda da Loja, para o e-mail do comprador.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          striped hover
          class="mt-4"
          :items="objResponse.orders_resent"
          :fields="fields"
          primary-key="id"
          sort-icon-left
          empty-filtered-text="Nenhum reenvio de pedido registrado"
          empty-text="Nenhum reenvio de pedido registrado"
          responsive
        >
          <template v-slot:cell(created_at_fmted)="data">
            <div>
              {{ data.item.created_at | date }} <br>
              <span class="data-extra">{{ data.item.created_at | dateRelative }}</span>
            </div>
          </template>
          <template v-slot:cell(order_number_action)="data">
            <div>
              <router-link :to="{name: 'Order', params: {id: data.item.order_id}}">{{ data.item.order_number }}</router-link> <icon scale="0.55" name="external-link-alt"></icon>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'AdminOrdersResent',
  data () {
    return {
      objResponse: '',
      fields: [
        { key: 'id', label: '#', class: ['align-middle', 'text-center'] },
        {key: 'order_number_action', label: 'Nro. pedido', class: ['text-nowrap', 'align-middle', 'text-center']},
        {key: 'event', label: 'Evento', class: ['align-middle', 'text-nowrap']},
        {key: 'email', label: 'Destino reenvio', class: ['align-middle', 'text-nowrap']},
        { key: 'created_at_fmted', label: 'Data solicitação reenvio', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'user_agent', label: 'Dispositivo', formatter: this.$options.filters.userAgent, tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'location', label: 'Local', tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
      ]
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      let url = process.env.VUE_APP_URL_APP + `/b/admin/orders/resent`
      try {
        let resp = await this.$http.get(url)
        this.objResponse = resp.body
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss">
.data-extra {
  font-size: 13px;
}
</style>
